<template>
  <div>

    <loader v-if="!isLoaded"></loader>

    <form novalidate>
      <div class="row wizard-tab-container">
        <div class="col-lg-8"  v-if="protocols">

          <h1 class="page-title mb-3">{{'protocol.mastering' | trans}}: <span v-if="protocolData">{{protocolData.protocol.title}}</span></h1>
          <div class="row mt-2 mb-4" v-if="isPreviousDateSession && protocolData && protocolData.endDate" ref="maxTotalAtemptsCountError" id="maxTotalAtemptsCountError">
            <div class="col-12">
              <div class="alert-danger text-center" v-if="showDatePrevious">
                {{'protocol.enter_another_session_date' | trans}} <strong>{{minDate | toLocaleDateTime}}</strong>
              </div>
              <div class="alert-secondary text-center" v-if="!showDatePrevious">
                {{'protocol.end_session_date' | trans}}: <strong>{{minDate | toLocaleDateTime}}</strong>
              </div>
            </div>
          </div>
  
          <div class="row">
            <div class="col-md-12 col-md-12 position-relative wrapper-loader"  v-if="protocols && !sessionView">
              <loader v-if="(!(previousDate && previousTime && previousTime.HH && previousTime.mm) && (isBCBA || isCurator) && isPreviousDateSession) || showDatePrevious" class="table-loader position-absolute without-img"
                      messages=""></loader>
              <div v-for="(level,index) in protocols.levels" class="row mt-3">
    
                <div class="col-md-12">
      
                  <h3 class="page-sub-title">{{'protocol.level' | trans}} "{{level.description}}"</h3>
      
                  <div class="row" v-if="level.groups.length">
                    <div class="col-md-6 mt-2"  v-for="(group, indexGroup) in level.groups">
                      <div class="alert cursor-pointer" @click.prevent="goToGroup(index, indexGroup)">
                        <h4 class="set-title">{{'protocol.set' | trans}} {{indexGroup+1}}</h4>
                        <p class="set-subtitle text-block__slash">
                          <span v-for="stimul in group.stimuli">{{stimul.description}}</span>
                        </p>
                        
                        <div class="row">
                          <div class="col-sm-4 pr-0 col-12 pt-2">
                            <div class="mastering-block" :class="session.masteringRatio >= protocols.masteringConditions.nextPhase.ratio ? 'green' : 'red'"  v-for="session in group.sessions.slice().reverse()">
                              <span class="line"></span>
                              {{session.masteringRatio}}%
                            </div>
                          </div>
                          <div class="col-sm-8 col-12 pr-sm-0 pt-2 pt-sm-0">
                            
                            <button type="button"
                                    v-if="index + 1 !== protocols.levels.length && group.canBeMovedForward  && !group.canBeMovedBack"
                                    class="btn btn-light float-right btn-xs"
                                    @click.stop="goToNextLevel(index, indexGroup)">
                              {{'protocol.next_block' | trans}} "{{protocols.levels[index + 1].description}}"
                            </button>
  
                            <button type="button"
                                    v-if="index + 1 === protocols.levels.length && group.canBeMovedForward  && !group.canBeMovedBack"
                                    class="btn btn-light float-right btn-xs"
                                    @click.stop="goToMaintain(index, indexGroup)">
                              {{'protocol.to_support' | trans}}
                            </button>
  
                            <button type="button"
                                    v-if="index  !== 0 && group.canBeMovedBack"
                                    class="btn btn-light float-right btn-xs"
                                    @click.stop="goToPrevLevel(index, indexGroup)">
                              {{'protocol.prev_block' | trans}} "{{protocols.levels[index - 1].description}}"
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          
          <div class="row mb-3" v-if="sessionView">
            <div class="col-md-12">
              <h3 class="page-sub-title">{{'protocol.level' | trans}}: {{protocols.levels[selectedIndex].description}}</h3>
              <h4 class="row-title text-block__slash mb-3" v-if="selectedGroup">
                {{'protocol.set' | trans}}: <span v-for="(stimul,index) in selectedGroup.stimuli">{{stimul.description}} {{shortDescripton ?  ' - ' + shortDescripton[index] : ''}} </span>
              </h4>
            </div>
            <div class="col-md-12 position-relative wrapper-loader">
              <loader v-if="(!(previousDate && previousTime && previousTime.HH && previousTime.mm) && (isBCBA || isCurator) && isPreviousDateSession) || showDatePrevious" class="table-loader position-absolute without-img"
                      messages=""></loader>
              
              <div class="session-block row" v-for="(block, blockIndex) in tempSessions.blocks" :key="block.uuid">
                <div class="col-md-12" :class="{'is-changed': block.isChanged}">
                    <div  :class="{'row_with_answer': !block.isChanged && ((selectedGroup.lastSession && selectedGroup.lastSession.blocks[blockIndex]) || block.answer), 'w33p': protocols.taskType.id !== 4}"
                        class="mdc-radio-wrapper auto-width mdc-form-field stimul-radio-wrapper"
                        v-for="(stimul, index) in block.stimuli" :key="index">
                      <div
                          class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                        <input :id="'id[' + blockIndex + '][' + index + ']'"
                               type="radio" class="mdc-radio__native-control"
                               :name="'radios[' + blockIndex + ']'"
                               :class="{'mdc-radio-checked__native-control': currentAnswer(stimul, blockIndex, block.answer)}"
                               :disabled="disabledRow(blockIndex) || (disableC(stimul) && protocols.taskType.id === 4)"
                               v-on:click="attemptChange(stimul,blockIndex, stimul.correct ? himselfAnswer : otherAnswer.id)">
                        <div class="mdc-radio__background list-cell" :class="{'active-cell': stimul.correct}">
                          <div class="mdc-radio__outer-circle"></div>
                          <div class="mdc-radio__inner-circle"></div>
                          <label :for="'id[' + blockIndex + '][' + index + ']'">{{stimul.name}}</label>
                        </div>
                      </div>
                    </div><div class="mdc-radio-wrapper auto-width mdc-form-field stimul-radio-wrapper"
                               :class="{'row_with_answer': (selectedGroup.lastSession && selectedGroup.lastSession.blocks[blockIndex]) || block.answer}" v-if="protocols.taskType.id === 4 && selectedIndex !== (protocols.levels.length - 1)">
                      <div
                          class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                        <input :id="'id[' + blockIndex + '][4]'"
                               type="radio" class="mdc-radio__native-control"
                               :class="{'mdc-radio-checked__native-control': currentAnswerPrompt(blockIndex)}"
                               :name="'radios[' + blockIndex + ']'"
                               :disabled="disabledRow(blockIndex)"
                               v-on:click="attemptChange('p',blockIndex, promptAnswer)">
                        <div class="mdc-radio__background list-cell prompt-cell">
                          <div class="mdc-radio__outer-circle"></div>
                          <div class="mdc-radio__inner-circle"></div>
                          <label :for="'id[' + blockIndex + '][4]'">P</label>
                        </div>
                      </div>
                    </div><div class="mdc-radio-wrapper auto-width mdc-form-field stimul-radio-wrapper"
                               :class="{'row_with_answer': (selectedGroup.lastSession && selectedGroup.lastSession.blocks[blockIndex]) || block.answer}" v-if="protocols.taskType.id === 4  && selectedIndex === (protocols.levels.length - 1)">
                      <div
                          class="mdc-radio mdc-ripple-upgraded mdc-ripple-upgraded--unbounded">
                        <input :id="'id[' + blockIndex + '][4]'"
                               type="radio" class="mdc-radio__native-control"
                               :class="{'mdc-radio-checked__native-control': currentAnswerError(blockIndex)}"
                               :name="'radios[' + blockIndex + ']'"
                               :disabled="disabledRow(blockIndex)"
                               v-on:click="attemptChange(otherAnswer.title,blockIndex, otherAnswer.id, true)">
                        <div class="mdc-radio__background list-cell error-cell" :class="{'error-active-cell': (block.answer && block.answer !== himselfAnswer) || currentAnswerError(blockIndex)}">
                          <div class="mdc-radio__outer-circle"></div>
                          <div class="mdc-radio__inner-circle"></div>
                          <label :for="'id[' + blockIndex + '][4]'">{{otherAnswer.title}}</label>
                        </div>
                      </div>
                    </div>
                  </div>
            
              </div>
            </div>
          </div>

        </div>
        <div class="col-lg-4" v-if="protocolData">
          <instruction :text="protocolData.protocol.execution"
                       :header="'protocol.execution' | trans"
                       :short-text-length="180">
          </instruction>
        </div>
      </div>

      <div class="form-group row form-group-button stage-button">
        <div class="col-md-12">
  
          <button type="submit"
                  v-if="!isClient && sessionView"
                  class="btn btn-primary btn-sm mr-2"
                  :disabled="answersLenght<9 || (isPreviousDateSession && protocolData && protocolData.endDate && showDatePrevious)"
                  @click.prevent="saveStage(false, true)">
            {{'protocol.next_session' | trans}}
          </button>


          <button type="submit"
                  v-if="!isClient"
                  :disabled="(isPreviousDateSession && protocolData && protocolData.endDate && showDatePrevious) || (!currentAnswersLenght && sessionView)"
                  class="btn btn-primary btn-sm mr-2  mt-2 mt-md-0"
                  @click.prevent="saveStage()">
            {{'buttons.save' | trans}}
          </button>

          <router-link class="btn btn-link btn-sm mr-2 mt-2 mt-md-0"
                       :to="{ name: 'choose-usd', params: {protocolData: protocolData, stageId:stageId}}" v-if="!sessionView">
            <span>{{'buttons.back' | trans}}</span>
          </router-link>
  
          <button type="submit"
                  v-if="sessionView"
                  class="btn btn-link btn-sm mr-2 mt-2 mt-md-0"
                  @click.prevent="sessionView = !sessionView">
            {{'buttons.back' | trans}}
          </button>

        </div>
      </div>
    </form>
  
    <mdc-dialog v-model="isConflictModalVisible"
                :title="'protocol.confirm_save_conflict_session' | trans"
                :accept="'user.save' | trans"
                :cancel="'user.cancel' | trans"
                @accept="saveSession(false)"
                @cancel="onModalClose">
    </mdc-dialog>
  
    <mdc-dialog v-model="chooseNextSessionModal"
                :title="'protocol.continue_or_new' | trans"
                :accept="'protocol.start_new' | trans"
                :cancel="'protocol.continue_previous' | trans"
                @accept="closePopup(true)"
                @cancel="closePopup(false)">
    </mdc-dialog>
  
    <mdc-dialog v-model="saveChangesPopup"
                :title="'protocol.save_set' | trans"
                :accept="'user.save' | trans"
                :cancel="'user.cancel' | trans"
                @accept="closeChangesPopup(true)"
                @cancel="closeChangesPopup(false)">
    </mdc-dialog>


  </div>
</template>

<script>
  import axios from 'axios';
  import Instruction from '@/common/instruction/components/InstructionView';
  import Loader from '../../loader/components/Loader';
  import forIn from 'lodash/forIn';
  import forEach from 'lodash/forEach';
  import forEachRight from 'lodash/forEachRight';
  import cloneDeep from 'lodash/cloneDeep';
  import findIndex from 'lodash/findIndex';
  import map from 'lodash/map';
  import drop from 'lodash/drop';
  import dropRight from 'lodash/dropRight';
  import keys from 'lodash/keys';
  import values from 'lodash/values';
  import moment from 'moment';
  import {mapGetters, mapActions, mapState} from 'vuex';
  import {TRANSFER_CONDITION, DATAPICKER} from '../../protocols/constants.js';
  import Constants from '../../undesirableBehavior/Constants';
  import UuidGenerator from '@/common/uuid/UuidGenerator';
  import filters from '../../../filters/filters';
  import filter from 'lodash/filter';
  import lang from '../../../lang/translator';
  import trim from 'lodash/trim';
  import maxBy from 'lodash/maxBy';
  import orderBy from 'lodash/orderBy';
  import fill from 'lodash/fill';
  import toInteger from 'lodash/toInteger';
  import concat from 'lodash/concat';
  import SetConstants from '../../randomRotation/Constants.js';

  export default {
    props: ['protocolId', 'phaseId', 'client', 'stageId', 'stage'],
    data() {
      return {
        apiUrl: '/protocols/assigned/vcd/',
        apiCheckedUrl: '/protocols/assigned/',
        isLoaded: false,
        protocols: null,
        isConflictModalVisible: false,
        changedGroup: [],
        sessionView: false,
        saveChangesPopup:false,
        setSessions: [],
        blocksLength: 9,
        blocksStimulusLength: 3,
        selectedGroup: null,
        currentSessionIndex: 0,
        selectedLevelUiid: null,
        answerList: [],
        chooseNextSessionModal: false,
        selectedIndexGroup: null,
        selectedIndex: null,
        tempSessions: null,
        shortDescripton: null,
        majorVersion: null,
        protocolData: null,
        stageInfo: this.stage,
        timerId: null,
        selectedRow: null,
        uuid: null
      };
    },

    components: {
      Instruction,
      Loader
    },

    computed: {
      ...mapGetters('auth', [
        'isClient',
        'isBCBA',
        'isCurator',
        'isPreviousDateSession',
        'previousDate',
        'previousTime',
        'previousDuration'
      ]),

      ...mapGetters('mobile', [
        'isMobile',
      ]),

      ...mapState('protocol', [
        'protocolVuexData',
      ]),

      rangeDateStartTimestamp() {
        return moment(this.previousDate).unix()
      },
      rangeDateEndTimestamp() {
        return moment(this.previousDate).unix() + 3600
      },
      minDate() {
        return this.protocolData.endDate ? moment(this.protocolData.endDate.date, 'YYYY-MM-DD HH:mm').toDate() : null;
      },
      
      himselfAnswer(){
        let active = filter(this.protocols.taskType.answers, 'himself');
        return active.length ? active[0].id : null;
      },

      promptAnswer(){
        let active = filter(this.protocols.taskType.answers, 'isPrompt');
        return active.length ? active[0].id : null;
      },

      otherAnswer(){
        let active = filter(this.protocols.taskType.answers, item => {return !item.himself && !item.isPrompt});
        return active.length ? active[0] : null;
      },

      showDatePrevious() {
        if (this.protocolData.endDate && this.isPreviousDateSession  &&  this.previousDate && this.isPreviousDateSession && this.previousTime && this.previousTime.HH && this.previousTime.mm){

          let protocolDate = moment(this.minDate).unix();
          let sessionDate = new Date(this.previousDate.getFullYear(),
              this.previousDate.getMonth(),
              this.previousDate.getDate(),
              this.previousTime.HH,
              this.previousTime.mm);

          let previous = moment(sessionDate).unix();
          return previous <= protocolDate;

        }

        return false;
      },
      currentAnswersLenght(){
        let answerLength = 0;

        if (this.sessionView) {

          let sessinAnswer = filter(this.tempSessions.blocks, block => {
            return block.answer
          });

          answerLength = sessinAnswer.length;
        }

        return answerLength;
      },
      answersLenght(){
        let answerLength = 0;

       if (this.sessionView) {

          let sessinAnswer = filter(this.tempSessions.blocks, block => {
            return block.answer
          });

          answerLength = this.selectedGroup.lastSession ? sessinAnswer.length + this.selectedGroup.lastSession.blocks.length : sessinAnswer.length;
        }
        
        return answerLength;
      }
    },

    async mounted() {
      
      if(!this.stage){
        let response = await axios.get(this.apiUrl + this.protocolId + '/show-stage/' + this.stageId);
        this.stageInfo = response.data.data;
      }

      this.protocolData = cloneDeep(this.protocolVuexData);

      this.fetchProtocol();
      
    },

    beforeDestroy() {
      //this.setProtocol(null)
    },

    methods: {

      ...mapActions('appeals', [
        'setEntity',
      ]),

      ...mapActions('protocol', [
        'setProtocol',
      ]),
      
      currentAnswer(stimul, index){
        let current = [];
        if (this.selectedGroup.lastSession){
          current = filter(this.selectedGroup.lastSession.blocks, block => {
            return block.index == index;
          });
          
        }
        
        return current.length && !current[0].isPrompt ? current[0].selectedStimulusUuid === stimul.stimulus.globalUuid : false;
      },

      currentAnswerPrompt(index){
        let current = [];
        if (this.selectedGroup.lastSession){
          current = filter(this.selectedGroup.lastSession.blocks, block => {
            return block.index == index;
          });

        }

        return current.length ? current[0].isPrompt : false;
      },

      currentAnswerError(index){
        let current = [];
        if (this.selectedGroup.lastSession){
          current = filter(this.selectedGroup.lastSession.blocks, block => {
            return block.index == index;
          });

        }

        return current.length ? !current[0].isHimself : false;
      },

      disabledRow(index){
        let current = [];
        let previous = [];
        let answPrev = false;
        let answNext = false;
        
        if (this.selectedGroup.lastSession){
          current = filter(this.selectedGroup.lastSession.blocks, block => {
            return block.index == index;
          });
          
          if (index > 0){
            previous = filter(this.selectedGroup.lastSession.blocks, block => {
              return block.index == index-1;
            });
            
          }
        }


        if (index > 0){
          
          answPrev = previous.length || this.tempSessions.blocks[index-1].answer

        }

        if (index < this.tempSessions.blocks.length -1){

          answNext = this.tempSessions.blocks[index+1].answer

        }

        return !!current.length || (!(answPrev || index == 0) && !answNext) ;
      },

      disableC(stimul){
        if (!this.selectedIndex){
          return stimul.correct;
        }
        
        return false;
        
      },
      

      fetchProtocol: async function(nextSession) {
        this.currentSesssionDate = Math.round((new Date()).getTime() / 1000);
   
        this.uuid = UuidGenerator.v4();
        let entity = {
          id: this.uuid,
          type: 'assigned-session',
        };

        this.setEntity(entity);
        
        
        this.isLoaded = false;

        this.changedGroup = [];

        let params = {};

        if(this.isPreviousDateSession && this.previousDate) {
          let newDate = moment(this.previousDate).format('YYYY-MM-DD');
          let newDateUnix = moment.utc(newDate, 'YYYY-MM-DD').unix();

          let timeSessionDate = moment.utc(this.previousDate).unix;
          params = {
            date: newDateUnix
          };

        }

        let response = await axios.get(this.apiUrl + this.protocolId + '/stage/' + this.stageId +'/phase/5', {
          params: params,
        });
        this.protocols = response.data.data;
        if(response){
          if (nextSession){
            this.showSession();
          }
          this.isLoaded = true;
        }

      },

      goToNextLevel(index, groupIndex){

        let levels = cloneDeep(this.protocols.levels);
        let group = this.protocols.levels[index].groups[groupIndex];
        let nextLevelGroup = cloneDeep(this.protocols.levels[index+1].groups);
        
        nextLevelGroup.push({
          uuid: group.uuid,
          index: group.index,
          id: group.id,
          moveForward: true,
          stimuli: group.stimuli,
          levelUuid: this.protocols.levels[index].uuid,
          sessions: [],
          lastSessionIndex: null,
          lastSession: null
        });
        
        this.changedGroup.push({
          uuid: group.uuid,
          index: group.index,
          id: group.id,
          moveForward: true,
          stimuli: group.stimuli,
          levelUuid: this.protocols.levels[index].uuid,
          sessions: []
        });
        levels[index].groups.splice(groupIndex, 1);
        levels[index + 1].groups = nextLevelGroup;
        this.$set(this.protocols, 'levels', levels);

      },

      goToPrevLevel(index, groupIndex){

        let levels = cloneDeep(this.protocols.levels);
        let group = this.protocols.levels[index].groups[groupIndex];
        let prevLevelGroup = cloneDeep(this.protocols.levels[index-1].groups);
        prevLevelGroup.push({
          uuid: group.uuid,
          index: group.index,
          id: group.id,
          moveBack: true,
          lastSessionIndex: null,
          lastSession: null,
          stimuli: group.stimuli,
          levelUuid: this.protocols.levels[index].uuid,
          sessions: []
        });
        
        this.changedGroup.push({
          uuid: group.uuid,
          index: group.index,
          id: group.id,
          moveBack: true,
          stimuli: group.stimuli,
          levelUuid: this.protocols.levels[index].uuid,
          sessions: []
        });
        levels[index].groups.splice(groupIndex, 1);
        levels[index - 1].groups = prevLevelGroup;
        this.$set(this.protocols, 'levels', levels);

      },

      goToMaintain(index, groupIndex){
        let levels = cloneDeep(this.protocols.levels);
        let  group = this.protocols.levels[index].groups[groupIndex];
        this.changedGroup.push({
          uuid: group.uuid,
          index: group.index,
          id: group.id,
          moveForward: true,
          stimuli: this.protocols.levels[index].groups[groupIndex].stimuli,
          levelUuid: this.protocols.levels[index].uuid,
          sessions: []
        });
        levels[index].groups.splice(groupIndex, 1);
        this.$set(this.protocols, 'levels', levels);
      },

      async checkSessionVersion() {
        
        let version = this.majorVersion ? this.majorVersion : this.protocols.majorVersion;

        let sessionVersion = axios.get(this.apiCheckedUrl + this.protocolData.id + '/is-version-equal/' + version);

        return sessionVersion;

      },


      async saveStage(close = false, nextSession = false) {
        this.isLoaded = false;

        let checkVersion = await this.checkSessionVersion();
        
        if (checkVersion.data.data.result) {
          this.saveSession(close, false, nextSession);
        } else{
          this.isLoaded = true;
          this.isConflictModalVisible = true;
        }

      },

      saveSession: async function(close, afterSave = false, nextSession = false) {
    
        let isSaved;
        this.isLoaded = false;
        this.errors.clear();

        let sessionDate = null;
        let timeSessionDate = null;
        let timeSessionEndDate = null;

        if (this.isPreviousDateSession && this.previousTime.HH){
          let clientTimeZoneOffset = moment().tz(this.client.timezone)._offset;
          sessionDate = new Date(Date.UTC(this.previousDate.getFullYear(),
            this.previousDate.getMonth(),
            this.previousDate.getDate(),
            this.previousTime.HH,
            this.previousTime.mm));
          timeSessionDate = moment(sessionDate).unix() - (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE);
          timeSessionEndDate = moment(sessionDate).unix() - (Math.abs(clientTimeZoneOffset) * Constants.SECONDS_PER_MINUTE) + this.previousDuration * Constants.SECONDS_PER_MINUTE;
        }

        let startedAt = this.isPreviousDateSession ? timeSessionDate : (this.currentSesssionDate ? this.currentSesssionDate : Math.round((new Date()).getTime() / 1000));
        let finishedAt = this.isPreviousDateSession ? timeSessionEndDate : Math.round((new Date()).getTime() / 1000);
     
        this.mastering = this.stageInfo ? filter(this.stageInfo.phases, function(item) { return item.typeId == 5; })[0] : null;
        let session = [];
        let answerList = [];
        if (this.sessionView){
          forEach(this.tempSessions.blocks, (block, index) => {
            if(block.answer){
              let target = !block.errorAnsw ? filter(block.stimuli, 'correct') : filter(block.stimuli, ['correct', false]);
              answerList.push({
                "targetStimulusDescription": target[0].stimulus.description,
                "targetStimulusUuid": target[0].stimulus.globalUuid,
                "selectedStimulusUuid": block.answer != this.promptAnswer && !block.errorAnsw ? block.answerStimul.stimulus.globalUuid : target[0].stimulus.globalUuid,
                "index": index,
                "isPrompt": block.answer == this.promptAnswer,
                "isHimself": block.answer == this.himselfAnswer,
                "answerId": block.answer
              });
            }
          });
          
          let answerLength = this.selectedGroup.lastSession ? answerList.length + this.selectedGroup.lastSession.blocks.length : answerList.length;
          
          session = [
            {
              "uuid": this.selectedGroup.uuid,
              "moveForward": false,
              "moveBack": false,
              "levelUuid": this.selectedLevelUiid,
              "sessions": [
                {
                  "uuid": this.selectedGroup.lastSession ? this.selectedGroup.lastSession.uuid : UuidGenerator.v4(),
                  "startedAt": startedAt,
                  "finishedAt": answerLength === 9 ? finishedAt : null,
                  "index": this.currentSessionIndex,
                  "blocks": answerList
                }
              ]
            }
          ];


        }
        
        this.disabled = false;

        isSaved = axios.post(this.apiUrl + this.protocolId + '/sessions',
          {
            'uuid': this.stageInfo.uuid,
            'close': close,
            'majorVersion': this.majorVersion ? this.majorVersion : this.protocolData.protocol.majorVersion,
            'assignedSessions': [
              {
                'uuid': this.uuid,
                'phaseId': this.mastering.id,
                'startedAt': startedAt ,
                'finishedAt': finishedAt,
                'stimuli': [],
                'type': this.protocols.taskType,
                'groups': this.sessionView ? session : this.changedGroup
              },
            ],

          }).then(response => {
            
            this.changedGroup = [];
            this.majorVersion = response.data.data.majorVersion;
            this.setProtocol(null);

            if(close){
              let stageActiveList = filter(this.protocolsData.protocol.stages, ['isClosed', false]);
              this.setProtocol(null);
              if (stageActiveList.length <= 1){
                this.$router.push({name: 'results', params: { clientId: this.clientId || this.assignedProtocolId, protocolId: this.protocolId }});
              } else{
                this.$router.push({name: 'stage-list', params: { clientId: this.clientId || this.assignedProtocolId, protocolId: this.protocolId }});
              }
            } else{
              if (sessionDate) {
                this.protocolData.endDate = {
                  date: new Date(this.previousDate.getFullYear(),
                      this.previousDate.getMonth(),
                      this.previousDate.getDate(),
                      this.previousTime.HH,
                      toInteger(this.previousTime.mm) + toInteger(this.previousDuration))
                };
              }


              if (!nextSession){
                this.sessionView = false;
              } else{
                this.currentSessionIndex++;
              }

              if(afterSave){
                this.fetchProtocol(afterSave);
              } else{
                this.fetchProtocol(nextSession);
              }

            }

            //this.$router.push({name: 'choose-usd', params: { client: this.client, protocolId: this.protocolId}});
    
          }).catch(error => {
            if (error.response) {
              this.disabled = false;
              this.isLoaded = true;
            }
          });

      },
      
      
      goToGroup(index, indexGroup){
        this.selectedIndex = index;
        this.selectedIndexGroup = indexGroup;
        this.selectedGroup = cloneDeep(this.protocols.levels[index].groups[indexGroup]);
        this.currentSessionIndex = toInteger(this.selectedGroup.lastSessionIndex);
        this.selectedLevelUiid = this.protocols.levels[index].uuid;
        if (this.changedGroup.length) {
          this.saveChangesPopup = true;
        } else{
          if (this.selectedGroup.lastSession){
            this.chooseNextSessionModal = true;
          } else{
            if(this.selectedGroup.lastSessionIndex !== null){
              this.currentSessionIndex++;
            }
            this.showSession();
          }
        }
      },
      
      showSession(){
        this.buildSet(this.selectedIndex, this.selectedIndexGroup);
        this.sessionView = true;
      },

      closePopup(next){
        this.chooseNextSessionModal = false;
        if(next){
          this.currentSessionIndex++;
        }
        this.buildSet(this.selectedIndex, this.selectedIndexGroup, next);
        this.sessionView = true;
      },

      closeChangesPopup(change){
        if (change){
          this.saveSession(false, true)
        }
        
        this.saveChangesPopup = false;

      },

      async buildSet(index, indexGroup, next) {
        this.setSessions =  [];
        this.selectedGroup = cloneDeep(this.protocols.levels[index].groups[indexGroup]);
        if(next){
          this.selectedGroup.lastSession = null;
        }
        let group = this.selectedGroup;
        let stimulus = group.stimuli;
        
        let descriptionLenght = 0;
        
        forEach(stimulus, item =>{
          descriptionLenght = item.description.length > descriptionLenght ? item.description.length : descriptionLenght;
        });
        
        //create temp stimulus block for creating another
        let tempStimulus = [
          stimulus[0],
          stimulus[1],
          stimulus[2]
        ];
        
        let tempAnotherStimulus = [
          'A',
          'B',
          'C'
        ];
        
        if (descriptionLenght > 8){
          this.shortDescripton = tempAnotherStimulus;
        }

        //temp blocks for session
        let session = {
          index: 1,
          blocks: []
        };

        //for each blocks row
        for (let i = 0; i < this.blocksLength; i++) {
          //temp block for each blocks row
          let stimuli = [];
          
          let uuid = UuidGenerator.v4();

          let block = {
            uuid: i + '' + uuid,
            index: i + 1,
            resultId: SetConstants.NO_ANSWER,
            stimuli: []
          };


          //for each stimulus create object and add to blocks
          for (let j = 0; j < this.blocksStimulusLength; j++) {
            stimuli[j] = {
              name: (descriptionLenght <= 8) ? tempStimulus[j].description : tempAnotherStimulus[j],
              stimulus: tempStimulus[j],
              position: j + 1,
              correct: false
            };
          }
          
          if(descriptionLenght > 8){
            tempAnotherStimulus.unshift(tempAnotherStimulus.pop());
          }

          tempStimulus.unshift(tempStimulus.pop());

          block.stimuli = stimuli;
          session.blocks[i] = block;
        }

        //add all blocks to each session
        this.tempSessions = session;

        this.setActiveStimulus(index, indexGroup);
        
      },

      setActiveStimulus(index, indexGroup) {
          //array with index of active items in row
          let firstStimulusByBlocks = [];
          let activeItems = [];
          let group = this.selectedGroup;


          //for each stimulus column
          for (let j = 0; j < this.blocksLength; j++) {
            let self = this;
            let itemIndex;


            if (j === 0) {
              //random number for checking active element in column
              let activeIndex = this.currentSessionIndex % 3;
              //set active
              self.tempSessions.blocks[j].stimuli[activeIndex].correct = true;

              //add to activeItems
              activeItems = activeItems.concat(activeIndex);
              itemIndex = activeIndex;
            }
            else if (j % 3 == 0){
              let newIndex = firstStimulusByBlocks[firstStimulusByBlocks.length - 1];

              switch (newIndex) {
                case 0:
                  this.tempSessions.blocks[j].stimuli[1].correct = true;
                  activeItems = activeItems.concat(1);
                  itemIndex = 1;
                  break;
                case 1:
                  this.tempSessions.blocks[j].stimuli[2].correct = true;
                  activeItems = activeItems.concat(2);
                  itemIndex = 2;
                  break;
                case 2:
                  this.tempSessions.blocks[j].stimuli[0].correct = true;
                  activeItems = activeItems.concat(0);
                  itemIndex = 0 ;
                  break;
              }
            }
            else {
              switch (activeItems[j-1]) {
                case 0:
                  this.tempSessions.blocks[j].stimuli[2].correct = true;
                  activeItems = activeItems.concat(2);
                  itemIndex = 2;
                  break;
                case 1:
                  this.tempSessions.blocks[j].stimuli[0].correct = true;
                  activeItems = activeItems.concat(0);
                  itemIndex = 0;
                  break;
                case 2:
                  this.tempSessions.blocks[j].stimuli[1].correct = true;
                  activeItems = activeItems.concat(1);
                  itemIndex = 1;
                  break;
              }
            }

            if (j % 3 == 0) {
              firstStimulusByBlocks = firstStimulusByBlocks.concat(itemIndex);
            }
          }

      },

      onModalClose () {
        this.isModalVisible = false;
        this.isConflictModalVisible = false;
      },

      attemptChange(stimul, index, answer, errorAnsw = false){
        if (this.timerId){
          clearTimeout(this.timerId);
        }

          //this.selectedRow = index;
          forEach(this.tempSessions.blocks ,block => {
            this.$set(block, 'isChanged', false);
          })
          this.$set(this.tempSessions.blocks[index], 'answerStimul', stimul);
          this.$set(this.tempSessions.blocks[index], 'answer', answer);
          this.$set(this.tempSessions.blocks[index], 'errorAnsw', errorAnsw);
          this.$set(this.tempSessions.blocks[index], 'isChanged', true);
        
        

        this.timerId = setTimeout(() => {
          this.$set(this.tempSessions.blocks[index], 'isChanged', false);
        }, 500);
      }



    },
    watch: {
      previousDate(newValue){
        this.fetchProtocol();
      },
      previousTime(newValue){
        if (this.protocolData.endDate && moment(this.previousDate).format('YYYY-MM-DD') == moment(this.protocolData.endDate.date).format('YYYY-MM-DD')) {
          this.fetchProtocol();
        }
      },
      isPreviousDateSession(newValue){
        if (!newValue){
          this.fetchProtocol();
        }
      }

    }

  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/MasteringStageUSD.vue